export function validateForm() {
    return {
        ajaxSubmit: false,
        isValid: false,
        isSuccess: false,
        isError: false,
        isSubmitting: false,
        message: '',
        errors: {},
        init() {
            console.log('validateForm init called'); // Debug
            if (this.$el.hasAttribute('data-ajax-submit')) {
                this.ajaxSubmit = true;
                console.log('data-ajax-submit attribute found'); // Debug
            } else {
                console.log('data-ajax-submit attribute NOT found'); // Debug
            }
            console.log('Form ajaxSubmit:', this.ajaxSubmit); // Debug
        },
        handleSubmit(event) {
            console.log('handleSubmit called'); // Debug
            let form = this.$el;
            let inputs = [...form.querySelectorAll("[data-rules]")];
            this.errors = {};
            this.isSubmitting = true;
            
            console.log('handleSubmit called, ajaxSubmit:', this.ajaxSubmit); // Debug

            Iodine.setErrorMessages({
                required: "This field is required",
            });

            inputs.map((input) => {
                if (input.offsetParent === null) return;
                
                let value = input.value;
                let rules = JSON.parse(input.dataset.rules);
                
                // For file inputs, check files.length instead of value
                if (input.type === 'file') {
                    value = input.files.length > 0 ? 'file_selected' : '';
                }
                
                let assertion = Iodine.assert(value, rules);

                if (assertion !== true) {
                    if (assertion.valid === false) {
                        this.errors[input.name] = assertion.error;
                    }
                }
            });

            if (Object.keys(this.errors).length > 0) {
                event.preventDefault();
                this.isSubmitting = false;
                return false;
            }

            // If validation passes and this is an AJAX form, handle it
            if (this.ajaxSubmit) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.handleAjaxSubmit();
                return false;
            }

            // If validation passes and this is a regular form, let it submit normally
            return true;
        },
        hasError(field) {
            return !!this.errors[field];
        },
        getError(field) {
            return this.errors[field];
        },
        handleAjaxSubmit() {
            this.isSuccess = false;
            this.isError = false;
            this.message = '';

            const form = this.$el;
            const formData = new FormData(form);

            // append uploaded file to FormData
            const fileInput = form.querySelector('input[type="file"]');
            if (fileInput && fileInput.files.length > 0) {
                formData.append('file', fileInput.files[0]);
            }

            const options = {
                method: 'POST',
                body: formData,
                headers: {
                  'Accept': 'application/json',
                }
            };

            // make a fetch request
            const actionInput = form.querySelector('input[name="action"]');
            const submitUrl = actionInput ? actionInput.value : '/contact-form/send';
            console.log('Submitting to:', submitUrl); // Debug
            fetch(submitUrl, options)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    return response.json();
                })
                .then((data) => {
                    setTimeout(() => {
                            this.isSubmitting = false;
                    }, 1000);

                    // set success message
                    this.isSuccess = true;
                    this.message = data.message;

                    form.reset();
                })
                .catch((error) => {
                    console.error(error);
                    this.isSubmitting = false;
                    this.isError = true;
                    this.message = 'There was an error submitting the form. Please try again.';
                });
        }
    }
}
